export { default as AddTitle } from './AddTitle';
export { default as AddTitleOverlay } from './AddTitleOverlay';




// WEBPACK FOOTER //
// ./app/components/shared/AddTitle/index.js